/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsFormConfiguration
 */
export interface VccCredentialsFormConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof VccCredentialsFormConfiguration
     */
    brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof VccCredentialsFormConfiguration
     */
    cardProviders?: Array<GuidIdAndLabel> | null;
}

export function VccCredentialsFormConfigurationFromJSON(json: any): VccCredentialsFormConfiguration {
    return VccCredentialsFormConfigurationFromJSONTyped(json, false);
}

export function VccCredentialsFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'cardProviders': !exists(json, 'cardProviders') ? undefined : (json['cardProviders'] === null ? null : (json['cardProviders'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function VccCredentialsFormConfigurationToJSON(value?: VccCredentialsFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandsAndMarkets': value.brandsAndMarkets === undefined ? undefined : (value.brandsAndMarkets === null ? null : (value.brandsAndMarkets as Array<any>).map(BrandAndMarketListItemToJSON)),
        'cardProviders': value.cardProviders === undefined ? undefined : (value.cardProviders === null ? null : (value.cardProviders as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


